export class CheckListItem {
    constructor(public id: number, public value: boolean, public display: string, public readonly: boolean = false) {

    }
}
